import styled, { css } from "styled-components";
import IconChecked from "@/styles/assets/svg/icon_checkbox_checked.svg";

interface InputCheckboxStyleProps {
  $size?: "sm" | "md" | "lg";
}

export const InputCheckbox = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 5px 10px;
`;

export const Label = styled.label<InputCheckboxStyleProps>`
  display: flex;
  padding: 6px;
  color: ${(props) => props.theme.colors.inputLabel};
  font-size: 1.4rem;
  line-height: 140%;
  align-items: center;
  flex-grow: 0;
  gap: 8px;

  input {
    appearance: none;
    width: 18px !important;
    height: 18px !important;
    padding: 0 !important;
    border: 1px solid ${(props) => props.theme.colors.inputBorder};
    border-radius: 4px;
    flex-shrink: 0;

    &:checked {
      background-image: url(${IconChecked});
      background-size: cover;
      background-position: center;
      border: none;
    }

    &:focus {
      border-width: 1px;
    }
  }

  ${(props) =>
    props.$size === "md" &&
    css`
      height: 34px;
    `}

  ${(props) =>
    props.$size === "md" &&
    css`
      height: 48px;
    `}

  ${(props) =>
    props.$size === "lg" &&
    css`
      height: 56px;
    `}
`;
